/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-lonely-if */
import React, { FC, useState } from 'react';
import { HostProvider } from '../../utils/HostProvider';
import NotFound from '../NotFound';
import TarjetasCaprabo from './indexCaprabo';
import TarjetasEroski from './indexEroski';
import { StorageHelper } from '../../utils/StorageHelper';
import { BackMappings } from '../../utils/BackMappings';
import useSessionChecking from '../../hooks/useSessionChecking';

const Tarjetas: FC = () => {
  const isCaprabo = HostProvider.isCaprabo();
  const isEroski = HostProvider.isEroski();
  const [goOn, setGoOn] = useState<boolean>(false);
  StorageHelper.setOrigin(BackMappings.TARJETA);
  useSessionChecking(BackMappings.TARJETA, setGoOn, goOn);

  if (isEroski) {
    return (
      <>
        <TarjetasEroski />
      </>
    );
  } else if (isCaprabo) {
    return (
      <>
        <TarjetasCaprabo />
      </>
    );
  } else {
    return <NotFound />;
  }
};
export default Tarjetas;
